import { initMap } from '../vendor/initMap';
import { dlog } from './devLibrary';
import { loadScript } from './loadingLibrary';
let $ = jQuery.noConflict();

export function handleFunctionalScript(obj, cookie, dMode = 0) {
	var isTrueSet = cookie === 'true';
	if (isTrueSet) {
		if (!document.getElementById(obj.id)) {
			dlog(dMode, 'script not present', 'HFS');
			loadScript(obj.url, obj.id)
				.then((data) => {
					dlog(dMode, 'script loaded', data);
					if ($('.mxms-map').length != 0) {
						dlog(dMode, 'mxms-map found', 'HFS');
						$('.mxms-map').each(function () {
							let map = initMap($(this));
						});
					}
				})
				.catch((err) => {
					console.log(err);
				});
		} else {
			dlog(dMode, 'script found', 'HFS');
			if ($('.mxms-map').length != 0) {
				dlog(dMode, 'mxms-map found', 'HFS');
				$('.mxms-map').each(function () {
					let map = initMap($(this));
				});
			}
		}
	}
}

export function handleMarketingScript(obj, cookie, dMode = 0) {
	var isTrueSet = cookie === 'true';
	if (isTrueSet) {
		if (!document.getElementById(obj.id)) {
			dlog(dMode, 'script not present', 'HMS');
			loadScript(obj.url, obj.id).then((data) => {
				dlog(dMode, 'script loaded', data);
				// console.log('script loaded', data);
				window.dataLayer = window.dataLayer || [];
				function gtag() {
					window.dataLayer.push(arguments);
				}
				gtag('js', new Date());
				gtag('config', obj.value);
			});
		} else {
			dlog(dMode, 'script found', 'HMS');
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				window.dataLayer.push(arguments);
			}
			gtag('js', new Date());
			gtag('config', obj.value);
		}
	}
}

export function fadeConsent(domObject) {
	domObject.fadeToggle();
}

export function createConsentToggleButton(domObject) {
	$('<div>', {
		class: 'no-consent__container'
	}).appendTo(domObject);

	$('<div>', {
		class: 'no-consent__inner'
	}).appendTo('.no-consent__container');

	$('<p>', {
		text: 'Aufgrund ihrer Datenschutzeinstellungen ist dieses Element leider nicht verfügbar. Passen Sie die Einstellungen an, um das Element anzuzeigen.'
	}).appendTo('.no-consent__inner');

	$('<a>', {
		text: 'Anpassen',
		title: 'title',
		id: 'id',
		class: 'button btn-show-cookie-consent',
		href: '#'
	}).appendTo('.no-consent__inner');
}
